<script setup lang="ts">
import { usePlaceStore } from "@/modules/place-module";
import { computed, ref } from "vue";
import { IconPhoneFill } from "@packages/icon-library";
import { UiTextButton } from "@packages/component-library";
import { formatPlaceContact } from "../../package/helpers/contacts-format";
import { useI18n } from "vue-i18n";

const placeStore = usePlaceStore();
const { t } = useI18n();
const place = computed(() => placeStore.place);
const showAllContacts = ref(false);
</script>

<template>
  <section class="place-contacts">
    <IconPhoneFill />

    <div class="place-contacts__info">
      <h4>{{ t("place.contacts.title") }}</h4>

      <div class="place-contacts__list">
        <a
          v-for="(contact, index) in showAllContacts
            ? place?.place.contacts
            : place?.place.contacts.slice(0, 5)"
          :key="index"
          :href="formatPlaceContact(contact)?.link"
          target="_blank"
        >
          {{ formatPlaceContact(contact).text }}
        </a>

        <UiTextButton
          v-if="!showAllContacts && place.place.contacts.length > 5"
          :label="t('place.contacts.showAllContacts')"
          size="m"
          @click="showAllContacts = true"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.place-contacts {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: calc($base-space * 2);
  align-items: start;

  @media (max-width: 1023px) {
    grid-template-columns: 20px 1fr;
  }

  > .icon {
    background-color: var(--color-semantic-content-normal-contrast-secondary);

    @media (max-width: 1023px) {
      width: 20px;
      height: 20px;
    }
  }

  &__info {
    > h4 {
      @include body-bold-l();
      color: var(--color-semantic-content-normal-primary);
    }
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr;
    gap: calc($base-space * 2);
    margin: calc($base-space * 3) 0 0;

    @media (max-width: 1023px) {
      margin: calc($base-space * 2) 0 0;
    }

    > a {
      text-transform: lowercase;
      @include body-m();
      color: var(--color-semantic-content-normal-primary);
      @include max-stroke(1);
    }
  }
}
</style>
